import { Link } from "react-router-dom";
import NewsletterSignup from "@/components/growth/NewsletterSignup";

const Footer = () => {
  return (
    <footer className="bg-gray-100 mt-auto">
      <div className="container mx-auto px-4 py-6 space-y-4">
        <div className="flex flex-col md:flex-row justify-between items-start gap-4">
          <div>
            <h3 className="text-sm font-semibold mb-2">Get Bayzo updates</h3>
            <NewsletterSignup />
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 pt-4 border-t">
          <div className="text-sm text-gray-600">
            © {new Date().getFullYear()} Bayzo. All rights reserved.
          </div>
          <nav className="flex flex-wrap justify-center gap-4 text-sm text-gray-600">
            <Link to="/privacy-policy" className="hover:text-gray-900">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-gray-900">
              Terms & Conditions
            </Link>
            <Link to="/refund-policy" className="hover:text-gray-900">
              Refund Policy
            </Link>
            <Link to="/contact" className="hover:text-gray-900">
              Contact Us
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;